<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="de_name,de_product_type,tar_project_classify,tar_decode"
      placeholder="输入项目名称、产品类型、项目分类进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/plm/technical_report/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.tar_code }}</p>
          <p class="list-item-muted">{{ item.de_product_type }}&nbsp;{{ item.de_name }}</p>
        </div>
        <div class="weui-cell__ft">
          <p >{{ item.tar_decode }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.tar_status != '已审核' }"
            >{{ item.tar_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/plm/technicalAnalyseReport/list",
      filters: [
        {
          type: "date",
          name: "a.createTime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "tar_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "tar_status='已审核'",
            },
          ],
        },
      ],
    };
  },
};
</script>